import { Dialog } from '@common/material'
import {
  backdropClasses,
  dialogClasses,
  DialogProps,
  modalClasses,
} from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { useModal } from '@common/GlobalModal'
import { useRouter } from 'next/router'
import {
  assignRef,
  ScrollContainerProvider,
} from '@common/ScrollContainerContext'

type ModalContainerProps = Omit<DialogProps, 'open'> & {
  open?: boolean
  preventDialogClose?: boolean
  closeOnBack?: boolean
}

export const ModalDialogContainer: React.FC<ModalContainerProps> = ({
  children,
  sx,
  onClose,
  preventDialogClose,
  closeOnBack,
  open = true,
  maxWidth = 'sm',
  PaperProps,
  ...rest
}) => {
  const { hideModal } = useModal()
  const router = useRouter()
  const [scrollContainer, setScrollContainer] = useState<HTMLDivElement | null>(
    null,
  )
  const paperRef = PaperProps?.ref as React.Ref<HTMLDivElement> | undefined
  const handlePaperRef = useCallback(
    (element: HTMLDivElement | null) => {
      setScrollContainer(element)
      assignRef(paperRef, element)
    },
    [paperRef],
  )

  const disableE2ETransitionsClasses = {
    [`.${modalClasses.root}`]: {
      transition: 'none !important',
    },
    [`.${modalClasses.hidden}`]: {
      transition: 'none !important',
    },
    [`.${dialogClasses.paper}`]: {
      transition: 'none!important',
    },
    [`.${dialogClasses.container}`]: {
      transition: 'none!important',
    },
    [`.${dialogClasses.root}`]: {
      transition: 'none!important',
    },
    [`.${backdropClasses.root}`]: {
      transition: 'none!important',
    },
  }

  if (closeOnBack) {
    useEffect(() => {
      const handlePopState = () => {
        // Push the current path again to stay on the same page
        router.push(router.asPath)
        hideModal()
      }

      window.addEventListener('popstate', handlePopState)

      return () => {
        window.removeEventListener('popstate', handlePopState)
      }
    }, [router])
  }

  return (
    <Dialog
      open={open}
      onClose={preventDialogClose ? () => {} : onClose || hideModal}
      sx={{
        ...sx,
        ...(Constants.E2E ? disableE2ETransitionsClasses : {}),
      }}
      maxWidth={rest.fullScreen ? false : maxWidth}
      fullWidth
      {...rest}
      PaperProps={{ ...PaperProps, ref: handlePaperRef }}
    >
      <ScrollContainerProvider value={scrollContainer}>
        {children}
      </ScrollContainerProvider>
    </Dialog>
  )
}
